import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {bindActionCreators} from 'redux'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import {FusePageSimple} from '../../../../@fuse/index'
import UecareListHeader from "../../../../components/header/UecareListHeader"
import ReduxFeedback from "../../../../store/actionreducers/feedback"
import FeedbackList from "./FeedbackList"
import FeedbackDialog from "./FeedbackDialog"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import { LinearProgress } from '@material-ui/core'

class feedbackApp extends Component {
    state = {
        feedback: {}
    }

    setFeedback = feedback => this.setState({feedback})

    async componentDidMount() {
        await this._reload()
    }

    async _reload() {
        this.setState({ isLoading: true })
        await this.props.fetchFeedbackList()
        this.setState({ isLoading: false })
    }

    render() {
        const {classes, feedbackList} = this.props

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='意見回饋列表' icon='insert_comment' reload={() => this._reload()} />
                    }

                    content={
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <FeedbackList setFeedback={this.setFeedback} feedbackList={feedbackList} />
                        </div>
                    }
                    sidebarInner
                />
                <FeedbackDialog feedback={this.state.feedback}/>
            </React.Fragment>

        )
    };
}


const headerHeight = 160

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: headerHeight,
        minHeight: headerHeight
    },
    layoutContentCardWrapper: {
        padding: 16,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        fetchFeedbackList: ReduxFeedback.ActionCreator.fetchFeedbackList,
    }, dispatch)
}

function mapStateToProps({feedback: {feedbackList}}) {
    return {feedbackList}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(feedbackApp)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/feedback/Feedback.js